import { render, staticRenderFns } from "./DeButton.vue?vue&type=template&id=965fb83c&scoped=true"
import script from "./DeButton.vue?vue&type=script&lang=js"
export * from "./DeButton.vue?vue&type=script&lang=js"
import style0 from "./DeButton.vue?vue&type=style&index=0&id=965fb83c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965fb83c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('965fb83c')) {
      api.createRecord('965fb83c', component.options)
    } else {
      api.reload('965fb83c', component.options)
    }
    module.hot.accept("./DeButton.vue?vue&type=template&id=965fb83c&scoped=true", function () {
      api.rerender('965fb83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget/deWidget/DeButton.vue"
export default component.exports